import { render, staticRenderFns } from "./quickview.vue?vue&type=template&id=a8925674&scoped=true&"
var script = {}
import style0 from "./quickview.scss?vue&type=style&index=0&id=a8925674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8925674",
  null
  
)

component.options.__file = "quickview.vue"
export default component.exports